export class TrapezParameter {
	public iMaterial: number = 0;
	public iTopChord: number = 0;
	public iBottomChord: number = 0;
	public iCalotteSize: number = 20;
	public iProfileHeight: number = 0;
	constructor() { }
}